import { Expose, Transform } from "class-transformer";
import { toCents } from "@/utils/numberUtils";

export class CreateUserHasPlusDto {
  @Expose()
  userId: string;

  @Expose()
  plusId: string;

  @Expose()
  @Transform(({ value }) => toCents(value))
  unitPrice: number;
}
